import withLazy from 'hoc/withLazy';

const PromoMatch = () =>
    import(/* webpackChunkName: "components-PromoMatch" */ './PromoMatch');

export default withLazy(PromoMatch);
